import styled from "styled-components";
import Button from "../button";
import { IButtonProps } from "../../@interfaces";

export const Botao = styled(Button)<IButtonProps>`
	padding: 7px 15px;
	box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
	width: 100px;
`